import downloadUrlAsFile from '@dashboard/services/downloadUrlAsFile';
import { apiUrl } from '@dashboard/services/env';
import { checkAuth, fetchWithNetworkErrorHandling } from '@dashboard/services/request';
import storage from '@dashboard/services/storage';

export const exportFileName = (contentDisposition: string | null, fallback: string) => {
  const match = contentDisposition?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  return match ? decodeURIComponent(match[1]) : fallback;
};

export async function exportAiChat(
  token: string | undefined,
  usageId: string,
  conversationId?: string,
) {
  const sellerId = storage.local.getItem('sellerId');
  const response: Response = await fetchWithNetworkErrorHandling(
    `${apiUrl}/admin/ai-usage/turns/${usageId}/export`,
    {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'x-access-token': token }),
        ...(sellerId && { 'X-Current-Seller-Id': sellerId }),
      },
    },
  ).then(checkAuth);

  if (!response.ok) throw new Error(`Export failed with status ${response.status}`);

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  downloadUrlAsFile(
    objectUrl,
    exportFileName(
      response.headers.get('Content-Disposition'),
      `ai-chat-${conversationId || usageId}.zip`,
    ),
  );
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
